import { createRouter, createWebHistory } from 'vue-router'
import HomeHome from '../views/HomeHome.vue'

const routes = [
  {
    path: '/',
    name: 'HomeHome',
    component: HomeHome
  },
  // Puedes agregar más rutas aquí
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
